import React from "react";
import DOMPurify from "dompurify";

const rawHTML = `
<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN">
<html>
<head>
<meta http-equiv="content-type" content="text/html; charset=utf-8"/>
<title></title>
<meta name="generator" content="LibreOffice 7.0.4.2 (MacOSX)"/>
<meta name="author" content="User"/>
<meta name="created" content="2021-11-25T20:36:00"/>
<meta name="changed" content="2021-12-02T22:47:40.214133871"/>
<meta name="AppVersion" content="14.0000"/>
<meta name="Company" content="Company"/>
<style type="text/css">
@page { size: 21cm 29.7cm; margin: 2.5cm  }
p { margin-bottom: 0.25cm; direction: ltr; line-height: 115%; text-align: left; orphans: 2; widows: 2; background: transparent  }
h5 { margin-top: 0.49cm; margin-bottom: 0.49cm; direction: ltr; line-height: 100%; text-align: left; orphans: 2; widows: 2; background: transparent  }
h5.western { font-family: "Times New Roman", serif; font-size: 10pt; font-weight: bold  }
h5.cjk { font-family: "Times New Roman"; font-size: 10pt; so-language: sr-Latn-RS; font-weight: bold  }
h5.ctl { font-family: "Times New Roman"; font-size: 10pt; font-weight: bold  }
h6 { margin-top: 0.35cm; margin-bottom: 0cm; direction: ltr; color: #243f60; line-height: 115%; text-align: left; page-break-inside: avoid; orphans: 2; widows: 2; background: transparent; page-break-after: avoid  }
h6.western { font-family: "Cambria", serif; font-style: italic  }
h6.cjk { font-family: ; font-style: italic  }
h6.ctl { font-family: ; font-style: italic  }
a:link { color: #0000ff; text-decoration: underline  }
a:visited { color: #800000; so-language: zxx; text-decoration: underline  }
</style>
</head>
<body lang="sr-Latn-RS" link="#0000ff" vlink="#800000" dir="ltr"><p align="center" style="margin-bottom: 0.49cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="2" style="font-size: 10pt"><b>PRIVACY
            POLICY<</b></font></font></p>
<p style="margin-top: 0.49cm; margin-bottom: 0.49cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="2" style="font-size: 10pt">INTRODUCTION</font></font></p>
<p align="justify" style="margin-top: 0.49cm; margin-bottom: 0.49cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="2" style="font-size: 10pt">At
        Prica Catering Ltd, we value your privacy and the importance of
        safeguarding your data. This Privacy Policy describes our privacy
        practices for the activities set out below. As per your rights, we
        inform you how we collect, store, access, and otherwise process
        information relating to individuals. In this Policy, &quot;Personal
        Data&quot; refers to any information that on its own, or in
        combination with other available information, can distinguish an
        individual.</font></font></p>
<p align="justify" style="margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="2" style="font-size: 10pt">We
        are committed to protecting your privacy in accordance with the
        highest level of privacy regulation. As such, we follow the
        obligations under:</font></font></p>
<ul>
    <li><p style="margin-top: 0.49cm; margin-bottom: 0cm; line-height: 100%; background: #ffffff">
    <font face="Arial, serif"><font size="2" style="font-size: 10pt">the
            EU's General Protection Data Regulation (GDPR)</font></font></p>
    <li><p style="margin-bottom: 0.49cm; line-height: 100%; background: #ffffff">
    <font face="Arial, serif"><font size="2" style="font-size: 10pt">Serbian
            Law on Personal Data Protection (SLPDP)</font></font></p>
</ul>
<p style="margin-top: 0.49cm; margin-bottom: 0.49cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="2" style="font-size: 10pt">The
        data controller is Prica Catering Ltd., Njegoseva St. No. 53, Nova
        Pazova, Serbia.</font></font></p>
<p style="margin-bottom: 0.51cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Scope</b></font></font></p>
<p align="justify" style="margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="2" style="font-size: 10pt">This
        policy applies to the our  Mobile and Desktop application.</font></font></p>
<p style="margin-bottom: 0.51cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Giving
            Consent</b></font></font></p>
<p style="margin-bottom: 0.51cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="2" style="font-size: 10pt">By
        entering your phone number and clicking „Login“ you are giving us
        consent for your personal data processing and you are accepting terms
        and conditions for Mobile and Desktop application using.</font></font></p>
<p style="margin-bottom: 0.51cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Processing
            Activities</b></font></font></p>
<p align="justify" style="margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="2" style="font-size: 10pt">This
        Privacy Policy applies when you interact with us by using our
        application and services as an authorized user.</font></font></p>
<p style="margin-bottom: 0.35cm">PERSONAL DATA WE COLLECT</p>
<table width="800" cellpadding="1" cellspacing="0">
    <col width="798"/>

    <tr>
        <td width="798" bgcolor="#ffffff" style="background: #ffffff" style="border: none; padding: 0cm"><p align="justify" style="orphans: 0; widows: 0">
            <font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Data
                        You Provide</b></font></font></p>
        </td>
    </tr>
    <tr>
        <td width="798" bgcolor="#ffffff" style="background: #ffffff" style="border: none; padding: 0cm"><p align="justify" style="margin-bottom: 0.42cm; orphans: 0; widows: 0">
            <font face="Arial, serif"><font size="2" style="font-size: 10pt">When
                    you use our application to make an order, or attempt to make an
                    order, we collect personal data as part of your order
                    information.</font></font></p>
            <p align="justify" style="margin-bottom: 0.42cm; orphans: 0; widows: 0">
            <font face="Arial, serif"><font size="2" style="font-size: 10pt">This
                    data includes your name, surname and phone number. Name and
                    surname we obtain from your employer. We use your phone number
                    just once for activation of Mobile and Desktop application.</font></font></p>
            <p align="justify" style="orphans: 0; widows: 0"><font face="Arial, serif"><font size="2" style="font-size: 10pt">If
                    you believe that your Personal Data has been provided to us
                    improperly, or to otherwise exercise your rights relating to your
                    Personal Data, please contact us by using the information set out
                    in the CONTACT US&nbsp;section below.</font></font></p>
        </td>
    </tr>
    <tr>
        <td width="798" bgcolor="#ffffff" style="background: #ffffff" style="border: none; padding: 0cm"><p align="justify" style="orphans: 0; widows: 0">
            <font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Purpose
                        and Legal Basis for the Processing of Personal Data</b></font></font></p>
        </td>
    </tr>
    <tr>
        <td width="798" bgcolor="#ffffff" style="background: #ffffff" style="border: none; padding: 0cm"><p align="justify" style="margin-bottom: 0.42cm; orphans: 0; widows: 0">
            <font face="Arial, serif"><font size="2" style="font-size: 10pt">We
                    collect and use personal data about you with your consent in order
                    to provide our service, i.e. to identify you to be able to accept
                    your order.</font></font></p>
            <p align="justify" style="orphans: 0; widows: 0"><font face="Arial, serif"><font size="2" style="font-size: 10pt">Where
                    we process your personal data to provide a service, we do so
                    because it is necessary to perform contractual obligations. All of
                    the above processing is necessary in our legitimate interests to
                    provide services to you. Consent will be required to initiate
                    services with you. New consent will be required If any changes are
                    made to the type of data collected. Within our contract, if you
                    fail to provide consent, services may not be available to you.</font></font></p>
        </td>
    </tr>
    <tr>
        <td width="798" bgcolor="#ffffff" style="background: #ffffff" style="border: none; padding: 0cm"><p align="justify" style="orphans: 0; widows: 0">
            <font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Sharing
                        and Disclosure</b></font></font></p>
        </td>
    </tr>
    <tr>
        <td width="798" bgcolor="#ffffff" style="background: #ffffff" style="border: none; padding: 0cm"><p align="justify" style="orphans: 0; widows: 0">
            <font face="Arial, serif"><font size="2" style="font-size: 10pt">We
                    will not share your personal data with third parties.</font></font></p>
        </td>
    </tr>
    <tr>
        <td width="798" bgcolor="#ffffff" style="background: #ffffff" style="border: none; padding: 0cm"><p align="justify" style="orphans: 0; widows: 0">
            <font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Legal
                        Requirement</b></font></font></p>
        </td>
    </tr>
    <tr>
        <td width="798" bgcolor="#ffffff" style="background: #ffffff" style="border: none; padding: 0cm"><p align="justify" style="orphans: 0; widows: 0">
            <font face="Arial, serif"><font size="2" style="font-size: 10pt">We
                    may use or disclose your personal data in order to comply with a
                    legal obligation, in connection with a request from a public or
                    government authority, or in connection with court or tribunal
                    proceedings, to prevent loss of life or injury, or to protect our
                    rights or property. Where possible and practical to do so, we will
                    tell you in advance of such disclosure.</font></font></p>
        </td>
    </tr>
    <tr>
        <td width="798" bgcolor="#ffffff" style="background: #ffffff" style="border: none; padding: 0cm"><p align="justify" style="orphans: 0; widows: 0">
            <font face="Arial, serif"><font size="3" style="font-size: 12pt"><b>Service
                        Providers and Other Third Parties</b></font></font></p>
        </td>
    </tr>
    <tr>
        <td width="798" bgcolor="#ffffff" style="background: #ffffff" style="border: none; padding: 0cm"><p align="justify" style="orphans: 0; widows: 0">
            <font face="Arial, serif"><font size="2" style="font-size: 10pt">We
                    will not use a third party service provider, independent
                    contractors, agencies, or consultants to deliver and help us
                    improve our services.</font></font></p>
        </td>
    </tr>
</table>
<p style="margin-bottom: 0.35cm">RETENTION &amp; DELITION</p>
<p style="margin-bottom: 0.35cm"><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">We
            will only retain your personal data for as long as necessary for the
            purpose for which that data was collected and to the extent required
            by applicable law. When we no longer need personal data, we will
            remove it from our systems and / or take steps to anonymize it in 6
            months.</span></font></font></p>
<p align="justify" style="margin-bottom: 0.35cm"><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">CHILDREN’S
            PRIVACY</span></font></font></p>
<p align="justify" style="margin-bottom: 0.35cm"><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">We
            will not knowingly collect personal data from children under the age
            of 15 Years.</span></font></font></p>
<p align="justify" style="margin-bottom: 0.35cm"><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">YOUR
            RIGHTS TO YOUR PERSONAL DATA</span></font></font></p>
<p align="justify" style="margin-top: 0.49cm; margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Times New Roman, serif"><font size="3" style="font-size: 12pt"><font face="Arial, serif"><font size="2" style="font-size: 10pt">Depending
                on your geographical location and citizenship, your rights are
                subject to local data privacy regulations. These rights may include:</font></font></font></font></p>
<ul>
    <li><h6 class="western" align="justify" style="margin-top: 0cm; margin-bottom: 0.42cm; line-height: 100%; page-break-inside: auto; background: #ffffff; page-break-after: auto">
        <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">Right
                    to Access (GDPR Article 15, </font></font></font><font face="Arial, serif"><font size="2" style="font-size: 10pt">SLPDP</font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">)</font></font></font></h6>
</ul>
<p align="justify" style="margin-left: 0.79cm; margin-top: 0.49cm; margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Times New Roman, serif"><font size="3" style="font-size: 12pt"><font face="Arial, serif"><font size="2" style="font-size: 10pt">You
                have the right to request a copy of the personal data we are
                processing about you.</font></font></font></font></p>
<ul>
    <li><h6 class="western" align="justify" style="margin-top: 0cm; margin-bottom: 0.42cm; line-height: 100%; page-break-inside: auto; background: #ffffff; page-break-after: auto">
        <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">Right
                    to Rectification (GDPR Article 16, </font></font></font><font face="Arial, serif"><font size="2" style="font-size: 10pt">SLPDP</font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">)</font></font></font></h6>
</ul>
<p align="justify" style="margin-left: 0.79cm; margin-top: 0.49cm; margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Times New Roman, serif"><font size="3" style="font-size: 12pt"><font face="Arial, serif"><font size="2" style="font-size: 10pt">You
                have the right to have incomplete or inaccurate personal data that we
                process about you rectified.</font></font></font></font></p>
<ul>
    <li><h6 class="western" align="justify" style="margin-top: 0cm; margin-bottom: 0.42cm; line-height: 100%; page-break-inside: auto; background: #ffffff; page-break-after: auto">
        <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">Right
                    to be Forgotten (right to erasure) (GDPR Article 17, </font></font></font><font face="Arial, serif"><font size="2" style="font-size: 10pt">SLPDP</font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">)</font></font></font></h6>
</ul>
<p align="justify" style="margin-left: 0.79cm; margin-top: 0.49cm; margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Times New Roman, serif"><font size="3" style="font-size: 12pt"><font face="Arial, serif"><font size="2" style="font-size: 10pt">You
                have the right to request that we delete personal data that we
                process about you, except we are not obliged to do so if we need to
                retain such data in order to comply with a legal obligation or to
                establish, exercise or defend legal claims.</font></font></font></font></p>
<ul>
    <li><h6 class="western" align="justify" style="margin-top: 0cm; margin-bottom: 0.42cm; line-height: 100%; page-break-inside: auto; background: #ffffff; page-break-after: auto">
        <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">Right
                    to Restriction of Processing (GDPR Article 18, </font></font></font><font face="Arial, serif"><font size="2" style="font-size: 10pt">SLPDP</font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">)</font></font></font></h6>
</ul>
<p align="justify" style="margin-left: 0.79cm; margin-top: 0.49cm; margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Times New Roman, serif"><font size="3" style="font-size: 12pt"><font face="Arial, serif"><font size="2" style="font-size: 10pt">You
                have the right to restrict our processing of your personal data where
                you believe such data to be inaccurate; our processing is unlawful;
                or if we no longer need to process such data for a particular purpose
                unless we are not able to delete the data due to a legal or other
                obligation or because you do not wish us to delete it.</font></font></font></font></p>
<ul>
    <li><h6 class="western" align="justify" style="margin-top: 0cm; margin-bottom: 0.42cm; line-height: 100%; page-break-inside: auto; background: #ffffff; page-break-after: auto">
        <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">Right
                    to Portability (GDPR Article 20, </font></font></font><font face="Arial, serif"><font size="2" style="font-size: 10pt">SLPDP</font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">)</font></font></font></h6>
</ul>
<p align="justify" style="margin-left: 0.79cm; margin-top: 0.49cm; margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Times New Roman, serif"><font size="3" style="font-size: 12pt"><font face="Arial, serif"><font size="2" style="font-size: 10pt">You
                have the right to obtain personal data we hold about you, in a
                structured, electronic format, and to transmit such data to another
                data controller, where this is (a) personal data which you have
                provided to us, and (b) if we are processing that data on the basis
                of your consent or to perform a contract with you or the third party
                that subscribes to services.</font></font></font></font></p>
<ul>
    <li><h6 class="western" align="justify" style="margin-top: 0cm; margin-bottom: 0.42cm; line-height: 100%; page-break-inside: auto; background: #ffffff; page-break-after: auto">
        <font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">Right
                    to Objection (GDPR Article 21, </font></font></font><font face="Arial, serif"><font size="2" style="font-size: 10pt">SLPDP</font></font><font color="#000000"><font face="Arial, serif"><font size="2" style="font-size: 10pt">)</font></font></font></h6>
</ul>
<p align="justify" style="margin-left: 0.79cm; margin-top: 0.49cm; margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Times New Roman, serif"><font size="3" style="font-size: 12pt"><font face="Arial, serif"><font size="2" style="font-size: 10pt">Where
                the legal justification for our processing of your personal data is
                our legitimate interest, you have the right to object to such
                processing on grounds relating to your particular situation. We will
                abide by your request unless we have compelling legitimate grounds
                for processing which override your interests and rights, or if we
                need to continue to process the data for the establishment, exercise
                or defense of a legal claim.</font></font></font></font></p>
<h5 class="western" align="justify" style="margin-bottom: 0.51cm; background: #ffffff">
    <font face="Arial, serif"><font size="3" style="font-size: 12pt">Withdrawing
            Consent</font></font></h5>
<p align="justify" style="margin-top: 0.49cm; margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Times New Roman, serif"><font size="3" style="font-size: 12pt"><font face="Arial, serif"><font size="2" style="font-size: 10pt">If
                you have consented to our processing of your personal data, you have
                the right to withdraw your consent at any time, free of charge. If
                you wish to withdraw your consent, please contact us by using the
                information set out in the CONTACT US&nbsp;section below.</font></font></font></font></p>
<h5 class="western" align="justify" style="margin-bottom: 0.51cm; background: #ffffff">
    <font face="Arial, serif"><font size="3" style="font-size: 12pt">How
            to Exercise Your Rights</font></font></h5>
<p align="justify" style="margin-top: 0.49cm; margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Times New Roman, serif"><font size="3" style="font-size: 12pt"><font face="Arial, serif"><font size="2" style="font-size: 10pt">You
                can make a request to exercise any of these rights in relation to
                your personal data by sending the request to e-mail address set out
                in the CONTACT US&nbsp;section below.</font></font></font></font></p>
<p align="justify" style="margin-top: 0.49cm; margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Times New Roman, serif"><font size="3" style="font-size: 12pt"><font face="Arial, serif"><font size="2" style="font-size: 10pt">For
                your own privacy and security, at our discretion, we may require you
                to prove your identity before providing the requested information.</font></font></font></font></p>
<p align="justify" style="margin-bottom: 0.35cm"><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">CHANGES</span></font></font></p>
<p align="justify" style="margin-bottom: 0.35cm"><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">We
            may modify this Policy at any time. If we make changes to this Policy
            then we will post an updated version of this Policy on this
            application. When using our services, you will be asked to review and
            accept our Privacy Policy. In this manner, we may record your
            acceptance and notify you of any future changes to this Policy.</span></font></font></p>
<p align="justify" style="margin-bottom: 0.35cm"><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">COMPLIANTS</span></font></font></p>
<p align="justify" style="margin-bottom: 0.42cm; line-height: 100%; background: #ffffff">
<font face="Arial, serif"><font size="2" style="font-size: 10pt">If
        you have a complaint about this Policy or any element of your
        personal information that we hold then please contact us below. If
        you are not satisfied, then you have the right to lodge a complaint
        with the local data protection authority.</font></font></p>
<p align="justify" style="margin-bottom: 0.35cm"><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">CONTACT
            US</span></font></font></p>
<p align="justify" style="margin-bottom: 0.35cm"><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">To
            request a copy for your information, request for your data to be
            deleted, or ask a question about your data privacy, please send
            e-mail to: </span></font></font><font color="#0000ff"><u><font color="#0000ff"><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">itpodrska</span></font></font></font></u></font><font color="#0000ff"><u><a href="mailto:office@pricacatering.com"><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">@pricacatering.com</span></font></font></a></u></font><font face="Arial, serif"><font size="2" style="font-size: 10pt"><span style="background: #ffffff">
</span></font></font></p>
<p align="justify" style="margin-bottom: 0.35cm"><br/>
<br/>

</p>
<p align="justify" style="margin-bottom: 0.35cm"><br/>
<br/>

</p>
<p align="justify" style="margin-bottom: 0.35cm"><br/>
<br/>

</p>
<p align="justify" style="margin-bottom: 0.35cm"><br/>
<br/>

</p>
</body>
</html>
`;

export default class Policy extends React.Component {
    render() {
        return (
            <div
                style={{
                    zIndex: 99999999999999999,
                    background: "white",
                    color: "black",
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "90",
                    height: "90vh",
                    padding: 40,
                }}
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(rawHTML),
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/Moduli/Policy.js